<template>
  <div class="Library centre">
    <div class="book-main">

      <div class="search-box">
        <div class="search">
          <el-input v-model="searchValue" placeholder="请输入关键词，例如题名/作者/版本" @keyup.enter.native="searchBtn"></el-input>
          <div class="search-title" @click="searchBtn">
            <span>|</span><span>搜索</span>
          </div>
        </div>
        <button class="seniorBtn" @click="showSenior = !showSenior">高级搜索</button>
      </div>

      <div class="advanced-search" v-show="showSenior">
        <Senior @baseSearch="baseSearch"></Senior>
      </div>

      <div class="book-list">

        <div class="book-result-text">
          <div class="result-text-header">
            <div class="result-text-left">
              <b>{{searchResultStr}}</b>
              <label>检索结果: <b> {{searchResult.count}} </b>部</label>
            </div>
            <div class="result-text-right">
              <span>排列方式: </span>
              <span :id="'span_'+ !showListPicture" class="result-text-right-click" @click="showListPicture = false">
                <i class="el-icon-s-operation"></i>列表
              </span>
              <span>|</span>
              <span :id="'span_'+ showListPicture" class="result-text-right-click" @click="showListPicture = true">
                <i class="el-icon-s-grid"></i>图文
              </span>
            </div>
          </div>
        </div>

        <div class="book-result-content" v-if="searchResult.list && 0 < searchResult.list.length">

          <div class="result-list" v-show="showListPicture" v-loading="$store.state.loading">
            <div class="result-list-content" v-for="item in searchResult.list">
              <div class="result-pic-left">
                <div class="picture" @click="onBook(item.bookId)"
                     :style="'background: url('+ item.coverPicture +') no-repeat top center /cover'"></div>
                <button @click="onBook(item.id)">查看详情</button>
                <p @click="collect($event ,item.id)">收藏</p>
              </div>
              <div class="result-pic-right">
                <table class="book-table">
                  <caption>{{toStr(item.title)}}</caption>
                  <tr>
                    <th>类别</th>
                    <td>{{toStr(item.classification)}}</td>
                  </tr>
                  <tr>
                    <th>作者</th>
                    <td>{{toStr(item.author)}}</td>
                  </tr>
                  <tr>
                    <th>年代</th>
                    <td>{{toStr(item.years)}}</td>
                  </tr>
                  <tr>
                    <th>版本类别</th>
                    <td>{{toStr(item.version)}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <div class="result-picture" v-show="!showListPicture">
            <el-table
              :data="searchResult.list"
              row-class-name="tableRowClassName"
              empty-text="暂无书籍"
              v-loading="$store.state.loading">
              <el-table-column align="center" label="书影" width="80">
                <template v-slot="{ row }">
                  <img class="book-list-coverPicture" :src="row.coverPicture" @click="onBook(row.id)">
                </template>
              </el-table-column>
              <el-table-column prop="title" label="题名"></el-table-column>
              <el-table-column prop="author" label="作者" width="220"></el-table-column>
              <el-table-column prop="years" label="年代" width="100">
              </el-table-column>
              <el-table-column prop="edition" label="版本" width="150"></el-table-column>
              <el-table-column label="操作" align="center" width="250">
                <template v-slot="{ row }">
                  <button class="btn" @click="collect($event ,row.id)">{{row.collectionBool ? '已收藏': '加入收藏'}}</button>
                  <button class="btn" @click="onBook(row.id)">查看详情</button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <Page :page="pageNo" :size="pageSize" :total="searchResult.count" @onPage="onPage"/>
        </div>

        <div v-else>
          <el-empty :description="empty"></el-empty>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import Page from "../../components/common/Page";
  import Senior from "../../components/library/Senior";
  import {addCollection, deleteCollectionById, listCollection} from "../../utils/router/library.api";

  export default {
    name: 'library',
    components: {Senior, Page},
    data() {
      return {
        empty: '加载中...',
        value: "",
        showSenior: true,
        typeId: this.$store.state.typeId,

        //普通检索
        searchValue: '',
        esParamsList: '',
        //图文 列表切换
        showListPicture: false,
        //检索结果
        searchResult: {
          count: 0,
          list: []
        },
        searchResultStr: '',
        searchList: [],
        esParamsList: [],
        pageNo: 1,
        pageSize: 12,
      };
    },
    methods: {
      searchBtn() {
        this.esParamsList = [
          {
            searchName: "title",
            searchRelation: 0,
            searchType: 0,
            searchValue: this.searchValue
          },
          {
            searchName: "author",
            searchRelation: 0,
            searchType: 0,
            searchValue: this.searchValue
          },
          {
            searchName: "edition",
            searchRelation: 0,
            searchType: 0,
            searchValue: this.searchValue
          },
        ]
        this.baseSearch()
      },
      seniorBtn() {
        this.baseSearch();
      },
      //查看详情
      onBook(bookId) {
        this.$router.push({
          path: '/detail',
          query: {
            key: this.$UrlEncode.encode(JSON.stringify({
              bookId: bookId
            }))
          }
        })
        //解密用  const id = JSON.parse(this.$UrlEncode.decode(this.$route.query.key)).bookId
      },
      //收藏
      collect($event, bookId) {
        if (this.loginState) {
          if ($event.target.innerText == '加入收藏') {
            addCollection({
              bookId: bookId,
              typeId: this.typeId,
              userId: this.$store.state.userInfo.userId,
              userName: this.$store.state.userInfo.userName,
            }).then(res => {
              if (res && res.data.code == 200) {
                $event.target.innerText = '已收藏'
              }
            })
          } else {
            deleteCollectionById({
              bookId: bookId,
              userId: this.$store.state.userInfo.userId,
            }).then(res => {
              if (res && res.data.code == 200) {
                $event.target.innerText = '加入收藏'
              }
            })
          }
        } else {
          this.$message("请先登录")
        }
      },
      //获取收藏列表 进行比对
      listCollection() {
        listCollection({
          typeId: this.typeId,
          userId: this.$store.state.userInfo.userId,
          userName: this.$store.state.userInfo.userName,
          page: 1,
          limit: 1000
        }).then(res => {
          if (res && res.data.data) {
            res = res.data.data.list
            res.map(coll => {
              this.searchResult.list = this.searchResult.list.map(data => {
                if (coll.bookId == data.id) {
                  data.collectionBool = true
                }
                return data
              })
            })
          }
        })
      },
      onPage(page) {
        this.pageNo = page
        this.baseSearch()
      },
      toStr(val) {
        return val ? val.toString() : '无'
      },
      //检索请求
      baseSearch(esParamsList) {
        esParamsList && (this.esParamsList = esParamsList)
        this.esParamsList = this.esParamsList.filter( res => res.searchValue)

        //默认添加审核状态和主从
        this.esParamsList.push({
          searchName: "examineState",
          searchRelation: 1,
          searchType: 1,
          searchValue: "1"
        }, {
          searchName: "masterSlave",
          searchRelation: 1,
          searchType: 1,
          searchValue: "主"
        })
        //去空
        this.esParamsList = this.esParamsList.filter(res => !!res.searchValue)

        this.$axios({
          method: 'post',
          url: '/portal/book/mainSearch',
          data: {
            typeId: this.typeId,
            userId: this.$store.state.userInfo.userId || '',
            //index1: "book",
            index1: "ancientbook",
            esParams: this.esParamsList,
            page: this.pageNo,
            limit: this.pageSize
          },
          header: {'Content-Type': 'application/json'}
        }).then(res => {
          if (res.data.code === 200) {
            this.searchResult = res.data.data
            this.searchResult.list.length == 0 && (this.empty = '没有匹配的资源')
            this.searchResult.list = this.searchResult.list.map(data => {
              if (!data.coverPicture || data.coverPicture == '/') {
                data.coverPicture = '/frontend/img/default.jpg'
              }
              return data
            })
            //收藏状态
            if (this.loginState) {
              this.listCollection()
            }
            this.searchResult.list.length == 0 && (this.empty = '暂无资源')
          }
        })
      },
    },
    created() {
      if (sessionStorage.getItem('portal_user_info')) {
        this.loginState = JSON.parse(sessionStorage.getItem('portal_user_info'));
      }
      if (this.$route.query.key) {
        this.searchValue = JSON.parse(this.$UrlEncode.decode(this.$route.query.key)).str
        this.searchBtn()
      }else{
        this.baseSearch()
      }
    }
  };
</script>

<style lang="less" scoped>
  .Library {
    .search-box {
      width: 766px;
      height: 56px;
      display: flex;
      margin: 20px auto;

      .search {
        display: flex;
        flex: 1;
        position: relative;

        .search-title {
          width: 90px;
          color: #654719;
          cursor: pointer;
          background: #fff;
          font-weight: bold;
          letter-spacing: 4px;
          line-height: 40px;
          position: absolute;
          top: 7px;
          right: 10px;

          span:first-child {
            font-size: 36px;
            padding-right: 6px;
          }

          span:last-child {
            font-size: 20px;
            position: relative;
            top: -6px;
          }
        }
      }

      .seniorBtn {
        width: 160px;
        height: 56px;
        border-radius: 10px;
        border: solid 2px #654719;
        background: #654719;
        color: #fff;
        font-size: 20px;
        font-family: "SimHei", "宋体", Arial, Helvetica;
        margin-left: 18px;
        letter-spacing: 4px;
        cursor: pointer;
      }

      /deep/ .el-input--small .el-input__inner {
        height: 56px;
        border-radius: 10px;
        border: 2px solid #654719;
        font-size: 18px;
      }

      /deep/ .el-input__inner:focus {
        border: 2px solid #654719;
      }
    }

    .book-main {
      width: 100%;
      max-width: 1400px;
      min-width: 1080px;
      min-height: 750px;
      flex-grow: 1;
      background-color: #ffffff;
      box-shadow: 0px 11px 30px 8px rgba(35, 35, 35, 0.35);
      margin: auto;
      box-sizing: border-box;
      padding: 20px 55px;

      /*检索结果*/

      .book-result-text {
        line-height: 43px;

        .result-text-header {
          height: 45px;
          line-height: 45px;
          padding-right: 20px;
          margin-top: 20px;

          span {
            padding: 5px;
          }
        }

        .result-text-left {
          float: left;
          text-indent: 10px;
        }

        .result-text-right {
          float: right;
        }

        #span_true {
          color: #654719;
          font-weight: bold;
        }

        .result-text-right-click {
          cursor: pointer;
          color: #797979;
        }

        .result-text-right-click:hover {
          color: #654719;
        }
      }

      .book-result-content {
        width: 100%;

        .result-list {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          background-color: #f9f9f9;
          padding: 20px;

          .result-list-content:hover {
            background-color: #e0dad1;
            border-radius: 5px;
          }

          .result-list-content {
            display: flex;
            flex-direction: row;
            padding: 10px 0px;
            border-bottom: solid 1px #eee;

            .result-pic-left {
              padding: 5px 10px;
              border-right: solid 3px #f0e9df;

              button {
                width: 119px;
                height: 30px;
                border: solid 1px #bfbfbf;
                background: #fff;
                margin-top: 20px;
                cursor: pointer;
              }

              button:hover {
                color: #fff;
                background: #654719;
              }

              p {
                width: 100%;
                margin-top: 30px;
                text-align: center;
                font-size: 21px;
                font-weight: bold;
                line-height: 42px;
                letter-spacing: 2px;
                cursor: pointer;
                color: #d68c0a;
              }
            }

            .picture {
              width: 119px;
              height: 165px;
              background: url("../../assets/img/library/default.jpg") no-repeat center center /cover;
              cursor: pointer;
            }

            .book-table {
              margin-left: 10px;

              caption {
                text-align: left;
                font-size: 21px;
                font-weight: bold;
                line-height: 42px;
                color: #343434;
              }

              th {
                width: 100px;
                height: 50px;
                font-size: 16px;
                letter-spacing: 2px;
                color: #797979;
                text-align: left;
              }

              td {
                width: 162px;
                font-size: 16px;
                font-weight: bold;
                color: #404040;
              }
            }
          }

          .result-list-name, .result-list-author {
            width: 278px;
          }
        }

        .result-picture {
          display: flex;
          flex-direction: column;

          /deep/ .el-table th {
            font-size: 16px;
          }

          /deep/ .tableRowClassName td {
            background-color: #f9f9f9;
            font-size: 16px;
          }

          /deep/ .tableRowClassName td {
            border-top: solid 3px #fff;
            border-bottom: solid 3px #fff;
          }

          /deep/ .el-table tbody tr:hover > td {
            background-color: #e0dad1;
          }

          .btn {
            width: 80px;
            height: 30px;
            background: #ccc;
            box-shadow: 2px 2px 2px #ccc;
            border: 0px;
            border-radius: 3px;
            margin-right: 10px;
            color: #333;
            cursor: pointer;
          }

          .el-button:hover, .btn:hover {
            color: #fff;
            background: #654719;
          }

          .book-list-coverPicture {
            width: 16px;
            height: 19px;
            cursor: pointer;
          }

          .result-picture-content {
            width: 100%;
            margin-top: 30px;
            border-bottom: solid 1px #ccc;
          }

          .result-picture-btn {
            width: 88px;
            height: 32px;
            border: solid 1px #654719;
            color: #654719;
            text-align: center;
            line-height: 32px;
            float: right;
            margin-top: -50px;
            margin-right: 30px;
            cursor: pointer;
          }

          /deep/ .el-descriptions__body {
            background: none;
          }

          /deep/ .el-descriptions-item__container {
            font-size: 16px;
          }
        }
      }
    }
  }
</style>
